export const confirmationStyle = {
  header: {
    sx: {
      color: 'text.primary',
    },
    style: {
      fontSize: '18px',
      fontWeight: 'bold',
      lineHeight: '25px',
      marginTop: '40px',
    },
  },
  subHeader: {
    sx: {
      color: 'text.secondary',
    },
    style: {
      fontSize: '14px',
      lineHeight: '22px',
    },
  },
} as const;
